import React, {Component} from 'react';
import assets from "../../../util/assets";
import "./index.css"
import util from "../../../util/clipstore/user/home";
import {getWalletBalance} from "@practicalcodelabs/moneyblox-dev";


class WalletBalanceBarComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: false,
            ghostBtnText: "Login",
            walletBalance: "0.00",
            formattedWalletBalance: "£ 0.00",
        }
    }

    componentDidMount() {
        this.checkIfLoggedIn();
    }

    checkIfLoggedIn = () => {
        util.checkLoggedIn((isLoggedIn) => {
            if (isLoggedIn) {
                getWalletBalance()
                    .then((payload) => {

                        if (payload.hasOwnProperty("wallet_balance")) {
                            this.setState({
                                isLoggedIn: true,
                                walletBalance: payload.wallet_balance,
                            }, () => {
                                this.setWalletBalance();
                                this.setGhostBtnText();
                            });

                            this.props.setWalletBalance(payload.wallet_balance);
                        }
                    })
                    .catch((error) => {
                        this.props.setWalletBalance("0.00");
                    });
            } else {
                this.setWalletBalance();
                this.setGhostBtnText();
            }
        })
    }

    setWalletBalance = () => {
        this.setState({
            formattedWalletBalance: `£ ${this.state.walletBalance}`
        })
    }

    setGhostBtnText = () => {
        this.setState({
            ghostBtnText: this.state.isLoggedIn ? "Add Credit" : "Login"
        })
    }

    clickAction = ()=>{
        if(this.state.isLoggedIn){
            this.props.showMoneyBloxModal();
        }else{
            util.showLogin(this.props);
        }
    }

    render() {
        return (
            <div className="wallet-balance-bar-container">
                <img src={assets.wallet} alt="Wallet" width={32}/>
                <span className="wallet-balance-bar-title">Wallet Balance</span>
                <span className="wallet-balance-bar-amount">{this.state.formattedWalletBalance}</span>
                <span className="wallet-balance-bar-ghost-btn" onClick={this.clickAction}>{this.state.ghostBtnText}</span>
            </div>
        );
    }
}


export default WalletBalanceBarComponent;
